define([
    'text!WebCommon/component/image-360-new.html',
    // 'common/api',
    'jquery',
    'vendor/swiper/swiper-bundle.min.js',//线上
    // '../../../../../vendor/swiper/swiper-bundle.min.js',//测试

    'css!vendor/swiper/swiper-bundle.min.css',
    'css!WebCommon/component/image-360-new.css'

], function(
    tpl,
    // Api,
    $,
    Swiper
){
    return {
        template: tpl,
        data: function(){
            return {

            };
        },
        // 这里是传入的数据
        props: {
            images: {
                type: Array,
                default: function () {
                    return []
                }
            },
            dotsShow: {
                type: Number
            },
            bgColor: String,
            SwiperType: String,
            selectedSkuExtra: Object
        },
        methods: {
            init: function () {
                if(this.SwiperType=='image360'){
                    new Swiper('#image360-new',{
                        // slidesPerView: 1,
                        // loop: true,
                        // spaceBetween: 1000,
                        // centeredSlides: true,
                        observer: true,
                        effect : 'fade',
                        autoplay: {
                            delay: 2500,
                            disableOnInteraction: false,
                        },
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true,
                        }
                    });
                }
            }
        },
        watch: {
            SwiperType: function () {
                this.init();
            }
        },
        mounted: function(){
            this.init();
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ../common/component/image-360-new.js
// module id = 313
// module chunks = 0